import { useReducer } from 'react';
import reducer, { DEFAULT_STATE } from './reducer';
import { EditSceneModalStateContextType } from './types';

export default function useEditSceneModalStateProvider(): EditSceneModalStateContextType {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE);

  return { state, dispatch };
}
